import { useMutation, useQueryClient } from "@tanstack/react-query";
import postsAPI from "../../api/posts/api";

export function useUpdatePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postsAPI.updatePost,
    onSuccess: (data, variables) => {
      // Invalidate and refetch posts list
      queryClient.invalidateQueries({ queryKey: ["posts"] });

      // Update specific post in cache
      queryClient.setQueryData(["posts", variables.id], data);
    },
    onError: (error) => {
      console.error("Update post failed:", error);
    },
  });
}
